import { parsePhoneNumber, getRegionCodeForCountryCode } from 'awesome-phonenumber'

export default (value?: string | null | number, countryCallingCode?: string | null) => {
  if (!value || !countryCallingCode) return false
  // remove + from country code
  countryCallingCode = countryCallingCode.replace('+', '')

  // Convert the value to string for consistency
  let phoneNumberStr = String(value)

  // Check if the phone number already starts with the country code
  // If it does, don't prepend the country code again
  const countryCodePrefix = `+${countryCallingCode}`
  const startsWithCountryCode =
    phoneNumberStr.startsWith(countryCodePrefix) || phoneNumberStr.startsWith(countryCallingCode)

  const regionCode = getRegionCodeForCountryCode(Number(countryCallingCode))

  // If the phone number already includes the country code, parse it directly
  // Otherwise, let the library handle it with the region code
  const phone = startsWithCountryCode
    ? parsePhoneNumber(phoneNumberStr)
    : parsePhoneNumber(phoneNumberStr, { regionCode })

  return phone.valid
}
